import React from 'react';

export const BridgeWaterPercentageSVG = ({
    fillColor = '#333',
    width = 50,
    height = 50
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 640 640"
        >
            {/* Centramos el puente verticalmente (desplazándolo unos 100px hacia abajo) */}
            <g transform="translate(0, 70)">
                <path
                    d="M64 128L576 128L576 240C538.4 249.4 512 283.2 512 322L512 398.4C491 388.7 468.5 383.9 446 384C436 384.1 425.9 385.1 416 387.1L416 352C416 299 373 256 320 256C267 256 224 299 224 352L224 384.7C218.7 384.2 213.3 383.9 208 384C180.3 384.2 152.6 391.8 128 407L128 322C128 283.2 101.6 249.4 64 240L64 128z"
                    fill={fillColor}
                />
            </g>
        </svg>
    );
};